/**
 * Serialize query params for Laravel: arrays as `key[]=a&key[]=b`.
 *
 * Axios 1.x defaults to repeated keys without brackets (`levels=a&levels=b`),
 * which PHP collapses to a string and Laravel rejects as "must be an array".
 *
 * @param {Record<string, unknown>} params
 * @returns {string}
 */
export function laravelParamsSerializer(params) {
    const search = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }

        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item === undefined || item === null) {
                    return;
                }
                search.append(`${key}[]`, String(item));
            });
            return;
        }

        search.append(key, String(value));
    });

    return search.toString();
}
